<template>
  <div class="page perf-detail">
    <div v-loading="loading" class="page-body page-body--narrow">
      <div class="detail-nav">
        <el-button type="text" icon="el-icon-arrow-left" @click="$router.push('/performance')">
          返回演艺列表
        </el-button>
      </div>
      <template v-if="detail">
        <div class="detail-header">
          <el-tag v-if="detail.category" type="danger" effect="plain" size="small">{{ detail.category }}</el-tag>
          <h1>{{ detail.title }}</h1>
          <ul class="detail-meta">
            <li v-if="detail.venue"><i class="el-icon-location-outline" /> {{ detail.venue }}</li>
            <li v-if="detail.duration"><i class="el-icon-time" /> {{ detail.duration }}</li>
          </ul>
          <p v-if="detail.intro" class="detail-intro">{{ detail.intro }}</p>
        </div>
        <div v-if="detail.content" class="detail-content">
          <h2>详细介绍</h2>
          <rich-content :content="detail.content" />
        </div>
        <div class="detail-actions">
          <el-button type="danger" round @click="$router.push('/service#ticket')">官方购票</el-button>
          <el-button round @click="$router.push('/service#wework')">咨询客服</el-button>
        </div>
      </template>
      <div v-else-if="!loading" class="page-empty">
        <i class="el-icon-warning-outline" />
        <p>内容不存在或已下架</p>
        <el-button type="text" @click="$router.push('/performance')">返回列表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import RichContent from '@/components/RichContent.vue';
import { getPerformance } from '@/api/performance';
import { resolveImageUrl } from '@/utils/image';
import { updateSeo } from '@/utils/seo';

export default {
  name: 'PerformanceDetail',
  components: { RichContent },
  data() {
    return {
      loading: false,
      detail: null
    };
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.loadDetail();
      }
    }
  },
  methods: {
    loadDetail() {
      const id = this.$route.params.id;
      if (!id) return;
      this.loading = true;
      this.detail = null;
      getPerformance(id)
        .then(res => {
          this.detail = res.data || null;
          if (this.detail) {
            updateSeo({
              title: this.detail.title,
              description: this.detail.intro || this.detail.title,
              keywords: [this.detail.category, this.detail.title, '百年票票', '西安演艺'].filter(Boolean).join(','),
              image: this.detail.coverImage ? resolveImageUrl(this.detail.coverImage) : '/logo.png',
              type: 'article'
            });
          }
        })
        .catch(() => {
          this.detail = null;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.detail-nav {
  margin: -8px 0 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}
.detail-nav .el-button--text {
  padding-left: 0;
  color: #606266;
  font-size: 14px;
}
.detail-nav .el-button--text:hover {
  color: #c41e3a;
}
.detail-header h1 {
  margin: 12px 0 16px;
  font-size: 28px;
  color: #303133;
  line-height: 1.4;
}
.detail-meta {
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 14px;
  color: #909399;
}
.detail-meta i {
  color: #c41e3a;
  margin-right: 4px;
}
.detail-intro {
  margin: 0;
  font-size: 16px;
  line-height: 1.8;
  color: #606266;
  padding: 16px;
  background: #fef0f2;
  border-radius: 8px;
}
.detail-content {
  margin-top: 32px;
}
.detail-content h2 {
  margin: 0 0 16px;
  font-size: 20px;
  color: #303133;
}
.detail-actions {
  margin-top: 36px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .detail-header h1 {
    font-size: 22px;
  }
  .detail-actions .el-button {
    flex: 1;
  }
}
</style>
